import Api from '../api'

const ApiPlugin = {
    install(Vue, options) {
        Vue.prototype.$api = new Api()
    }
}
export default ApiPlugin;


// WEBPACK FOOTER //
// ./requests/assets/src/plugins/Api.js